import {
    setLocalStorageItem,
    deleteLocalStorageItem
} from "../general/LocalStorageManager";

const MainAuthProvider = {
    isAuthenticated: false,
    signin(callback: VoidFunction) {
        MainAuthProvider.isAuthenticated = true;
        setTimeout(callback, 100);

        // Set the received token from the async call
        // To the localStorage Manager.
        setLocalStorageItem("pg-token", "test");
    },
    signout(callback: VoidFunction) {
        MainAuthProvider.isAuthenticated = false;
        setTimeout(callback, 100);
    }
};
  
export { MainAuthProvider };